var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwStep7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 75,
    viewBox: "0 0 61 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8571 37.7011V67.1025C59.8571 70.7117 56.9338 73.6349 53.3247 73.6349H7.59784C3.98871 73.6349 1.06543 70.7117 1.06543 67.1025V37.7011C1.06543 34.092 3.98871 31.1687 7.59784 31.1687H14.1302L18.9087 22.9835C19.4933 21.9828 20.5727 21.3644 21.7308 21.3644H39.0568C40.2037 21.3644 41.2605 21.9603 41.8564 22.9498L46.8035 31.1687H53.3359C56.9338 31.1687 59.8571 34.092 59.8571 37.7011Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6585 63.7408C37.8492 63.7408 43.6784 57.9116 43.6784 50.721C43.6784 43.5303 37.8492 37.7011 30.6585 37.7011C23.4679 37.7011 17.6387 43.5303 17.6387 50.721C17.6387 57.9116 23.4679 63.7408 30.6585 63.7408Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0028 51.047C25.3401 51.7441 25.8236 52.3062 26.2396 52.7784C27.0154 53.6329 27.8923 54.3863 28.7356 55.1171C29.1853 55.5106 29.6463 55.9041 30.0848 56.3089C30.3771 56.5787 30.6919 56.7136 31.0068 56.7136C31.3328 56.7136 31.6589 56.5787 31.9625 56.2976C32.8057 55.5443 33.649 54.791 34.481 54.0377C35.358 53.2507 35.9988 52.5536 36.516 51.8452C37.1344 51.002 37.4042 50.0575 37.3143 49.0569C37.2131 47.9888 36.6847 47.1792 35.7852 46.707C34.1774 45.8525 32.2773 46.0212 30.9955 47.0893C29.9949 46.2573 28.7468 45.9874 27.3751 46.2798C26.3745 46.4934 25.6662 46.9431 25.1827 47.629C24.9241 48.0112 24.8117 48.416 24.7217 48.7421L24.6992 49.9788L24.733 50.215C24.8004 50.4736 24.8679 50.7546 25.0028 51.047Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2832 2.73413L24.9578 4.36442",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2324 11.785L16.8627 12.4596",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1401 11.785L44.5098 12.4596",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0896 2.73413L36.415 4.36442",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6924 1.46362V6.74801",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8643 6.35449L22.5971 10.0985",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4113 18.1826H42.127H47.4113Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9619 18.1826H19.2463",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5092 6.35449L38.7764 10.0873L42.5092 6.35449Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep7);
export default __webpack_public_path__ + "static/media/ww-step7.8795f7d4.svg";
export { ForwardRef as ReactComponent };